import { useContext } from "react";
import { Link } from "react-router-dom";

import { AuthContext } from "../components/AuthContext";
import { hasTutoringToolsAccess } from "./tutoringToolsAccess";

export default function RequireTutoringToolsAccess({ children, title = "Narzędzie w fazie testowej", description }) {
  const { user, isAuthReady, entitlements } = useContext(AuthContext);

  if (!isAuthReady) return null;
  if (hasTutoringToolsAccess(user, entitlements)) return children;
  if (user?.role === "student" && entitlements == null) return null;

  return (
    <div className="glass-container" style={{ padding: 22, maxWidth: 680, margin: "0 auto" }}>
      <h1 style={{ marginTop: 0, fontSize: "1.45rem" }}>{title}</h1>
      <p style={{ lineHeight: 1.55, opacity: 0.88 }}>
        {description || "Interaktywna tablica i wykres funkcji są obecnie dostępne tylko dla uczniów przypisanych do korepetytora. Zwykły dostęp do kursu ani opłacona subskrypcja nie włączają tych narzędzi."}
      </p>
      <Link to="/" className="btn-secondary" style={{ display: "inline-flex", textDecoration: "none" }}>
        Wróć na stronę główną
      </Link>
    </div>
  );
}

